import {ORDERS_FAILURE, ORDERS_REQUESTING, ORDERS_SUCCESS} from "../types";

export const initialState = {
    ready: 'invalid',
    err: null,
    entities: [],
    paid: {
        '1' : 'نقدی',
        '2' : 'کارت به کارت',
        '3' : 'چک',
        '4' : 'اعتباری',
        '5' : 'آنلاین',
    },
    confirmed: {
        '1': 'تایید شده',
        '2' : 'تایید نشده',
    },
    transport: {
        '1': 'در حال آماده سازی',
    },
    delivery: {
        '1': 'تحویل پست',
        '2': 'تحویل پست',
        '3': 'درخواست مرجوعی',
    },
    returned: {
        '1': 'عدم تحویل',
        '2': 'خرابی یا ناقصی',
        '3': 'مرجوعی',
    }
};

export default function ordersReducer(state = initialState, action) {
    switch (action.type) {
        case ORDERS_REQUESTING:
            return {
                ...state,
                ready: 'request'
            };
        case ORDERS_SUCCESS:
            return {
                ...state,
                ready: 'success',
                entities: action.payload,
            };
        case ORDERS_FAILURE:
            return {
                ...state,
                ready: 'failure',
                err: action.err
            };
        default:
            return state;
    }
};
